const createImage = (url: string) =>
    new Promise<any>((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', error => reject(error))
        image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    })

export function dataURLtoFile(base64: string, fileName: string) {

    var arr = base64.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
}

export function validateAllowedFileType(fileType: string, allowedTypes: string[]) {
    // if types are not specified - assume all are allowed
    if (allowedTypes.length == 0) return true

    // check if file type is allowed 
    let isAllowed = allowedTypes.find(t => t == fileType)
    if (isAllowed) return true

    // get base type 
    let [base, type] = fileType.split("/")

    // find in allowed types based on base type 
    let allowed = allowedTypes.filter(t => t.startsWith(base))
    if (allowed.length == 0) return false

    // check if all subtypes are allowed 
    let allowedAll = allowed.find(t => t == [base, "*"].join("/"))
    return allowedAll != undefined
}


export function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
    return uuid;
}